import { getCmsDestinationBySlug } from "../../../app/api/getCmsDestinationBySlug";
import { getCmsNetworkMapStationsBySlug } from "../../../app/api/getCmsNetworkMapStationsBySlug";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IApiResponse, ICmsNetworkDetail, ICmsNetworkDetailResponse, IGetNetworkDetailActionParams } from "../../../Orchestrator/Types/Index";
import { stopAction } from "../Search/GetStopsAction";
import { getBestPriceForPopularTripsAction } from "./GetBestPriceForPopularTripsAction";

class GetCmsNetworkDetailAction extends BaseAction<ICmsNetworkDetail[], IGetNetworkDetailActionParams> {
  override async run(): Promise<ICmsNetworkDetail[] | null> {
    let detailData: ICmsNetworkDetail[] = [];
    try {
      updateRecoilState("networkDetailResponseAtom", null);

      //Call Get Stops API to fetch the Ammenities
      await stopAction.execute();

      const { slug } = this.params!;
      const response: IApiResponse<ICmsNetworkDetailResponse> = await getCmsNetworkMapStationsBySlug(slug);
      if (response.status === "ok" && response.answer) {
        const stationData = response.answer.data;
        if (stationData.length > 0) {
          detailData = stationData;
          updateRecoilState("networkDetailResponseAtom", detailData[0]);

          // Loop through each station and its popular_trips
          if (detailData[0]) {
            const from = detailData[0]?.station.code;
            if (detailData[0]?.popular_trips && Array.isArray(detailData[0]?.popular_trips)) {
              for (const popularTrip of detailData[0]?.popular_trips) {
                const to = popularTrip.code;
                if (from && to) {
                  getBestPriceForPopularTripsAction.setParams({ from, to });
                  await getBestPriceForPopularTripsAction.run();
                }
              }
            }
          }
        } else {
          console.warn("No stationData available.");
        }
      } else {
        console.warn("Failed to fetch stationData.");
      }
    } catch (error: any) {
      console.error("Error fetching stationData:", error);
    } finally {
      return detailData;
    }
  }
}

export const getCmsNetworkDetailAction = new GetCmsNetworkDetailAction();
